'use strict';

/**
 *
 * @name: nnFooterMain
 *
 */
// import _throttle from 'lodash.throttle'
import _debounce from 'lodash.debounce'

import DirectiveTemplate from './nn-header-main.directive.html';
import './nn-header-main.directive.scss';

function NnHeaderMainDirective() {

  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: DirectiveTemplate,
    controller: nnHeaderMainDirectiveController
  };
}

function nnHeaderMainDirectiveController($scope, $rootScope, nnModalsService, $element) {

  'ngInject';

  /*
   *
   * @CONFIG
   *
   */

  // let adSettings = null
  $rootScope.isNownessHeaderFixed = true
  // $scope.adIsVisibleForThatPost = true
  $scope.googleAds = [
    () => ({
      'jsonData': {
        'sources': [],
        'adType': 'image',
        'adUnit': 'NN_Top',
        'adSizes': [
          [
            300,
            300
          ],
          [
            768,
            1024
          ],
          [
            2560,
            1600
          ],
          [
            414,
            736
          ]
        ],
        'meta': {
          'name': null
        }
      }
    }),
    () => ({
      'jsonData': {
        'sources': [],
        'adType': 'video',
        'adUnit': 'NN_Top_Standard',
        'adSizes': [
          [
            300,
            300
          ],
          [
            300,
            600
          ],
          [
            768,
            1024
          ],
          [
            1024,
            400
          ],
          [
            414,
            736
          ],
          [
            2560,
            1600
          ],
          [
            728,
            400
          ],
        ],
        'meta': {
          'name': null
        }
      }
    })
  ]


  $rootScope.header = {
    mainNav: {
      visible: false,
      onNavClick: function() {
        $rootScope.analytics.topNavButton('Burger');
        console.log('mainNav')
        if ($rootScope.header.mainNav.visible && $rootScope.header.userNav.visible) {
          $rootScope.header.userNav.visible = false;
        }
      }
    },
    userNav: {
      visible: false,
      onNavClick: function() {
        $rootScope.analytics.topNavButton('User');
      },
      toggle: function() {

        if ($rootScope.profile === false) {

          nnModalsService.toggleModal('login')

        } else {

          $rootScope.header.userNav.visible = !$rootScope.header.userNav.visible;
          if($rootScope.header.userNav.visible){
            window._hmt.push(['_trackEvent', '首页-个人中心', 'click', '首页-个人中心']);
          }
        }
      }
    },
    show: function({ item, navClick }) {
      // If element has custom logic
      if (this[item].show) {

        if (navClick && this[item].onNavClick) {
          this[item].onNavClick()
        }
        this[item].show({ navClick })
        return
      }

      // Default
      if (navClick && this[item].onNavClick) {
        this[item].onNavClick()
      }
      this[item].visible = true
    },
    hide: function({ item, navClick }) {
      // If element has custom logic
      if (this[item].hide) {

        if (navClick && this[item].onNavClick) {
          this[item].onNavClick()
        }
        this[item].hide()
        return
      }

      // Default
      if (navClick && this[item].onNavClick) {
        this[item].onNavClick()
      }
      this[item].visible = false
    },
    toggle: function({ item, navClick }) {

      // If element has custom logic
      if (this[item].toggle) {

        if (navClick && this[item].onNavClick) {
          this[item].onNavClick()
        }
        this[item].toggle()
        return
      }

      if (this[item].visible) {

        this.hide({ item, navClick })
      } else {
        window._hmt.push(['_trackEvent', '首页-左侧菜单按钮', 'click', '首页-左侧菜单按钮']);
        this.show({ item, navClick })
      }
    }
  }

  $scope.closeAllModals = () => {
    nnModalsService.hideModal()
  }

  /*
   *
   * @PUBLIC
   *
   */

  $scope.changePlayerDrawerVisibility = (val = 'toggle') => {

    $rootScope.showDrawerVideo = val === 'toggle' ? !$rootScope.showDrawerVideo : val;
    if ($rootScope.showDrawerVideo){
      window._hmt.push(['_trackEvent', '首页-播放列表按钮', 'click', '首页-播放列表按钮']);
    }
  }

  /*
   *
   * @PRIVATE
   *
   */

  function _handleHeaderPosition () {
    if ($rootScope.lang === 'zh-cn') {
      return
    }

    console.log('nn-header-main.directive.js - _handleHeaderPosition()')

    let ticking
    let latestKnownScrollY = 0
    let adsContainer = $element[0].querySelector('#js-header-ads')

    function update() {
      $rootScope.adsHeaderHeight = adsContainer.getBoundingClientRect().height
      ticking = false;

      if (latestKnownScrollY > $rootScope.adsHeaderHeight) {
        $scope.$apply(() => {
          $rootScope.isNownessHeaderFixed = true
        })
      } else {
        $scope.$apply(() => {
          $rootScope.isNownessHeaderFixed = false
        })
      }
    }

    function requestTick() {
      if(!ticking) {
        requestAnimationFrame(update);
      }
      ticking = true;
    }

    function onScroll() {
      latestKnownScrollY = window.scrollY
      requestTick()
    }

    window.removeEventListener('scroll', onScroll, false)
    window.addEventListener('scroll', onScroll, false);

    if ($rootScope.adsHeaderHeight === 0) {
      window.removeEventListener('scroll', onScroll, false)
      $rootScope.isNownessHeaderFixed = true
     window.isNownessHeaderFixed = true
    }

    const interval = setInterval(() => {
      console.log('nn-header-main.directive.js Interval')
      update()
    }, 300)

    setTimeout(() => {
      clearInterval(interval)
    }, 5000)
  }

  // function _checkAdVisibility () {
  //   if (!adSettings) return;

  //   if (!Object.keys($rootScope.post).length) {
  //     $scope.adIsVisibleForThatPost = true;
  //   }

  //   const isCurrentPostOnTheList = adSettings.posts.some(post => post.id === $rootScope.post.id)

  //   if (adSettings.type === 'blacklist') {
  //     $scope.adIsVisibleForThatPost = !isCurrentPostOnTheList
  //   } else if (adSettings.type === 'whitelist') {
  //     $scope.adIsVisibleForThatPost = isCurrentPostOnTheList
  //   }
  // }

  // function _getAdSettings () {
  //   const target = $rootScope.apiUrlBak + '/settings/HEADER_AD_VISIBILITY'
  //   $http.get(target)
  //     .then(res => {
  //       const {data} = res.data;
  //       adSettings = data
  //       _checkAdVisibility()
  //     })
  //     .catch(() => {
  //       return;
  //     });
  // }


  /*
   *
   * @INIT
   *
   */


  // const scrollHandle = _throttle(() => {
  //   $scope.$apply($scope.changePlayerDrawerVisibility(false))
  //    window.removeEventListener('scroll', scrollHandle)
  // }, 500)

  // $rootScope.$watch('showDrawerVideo', val => {
  //   if (val) {
  //     window.addEventListener('scroll', scrollHandle)
  //   }
  // })

  // $scope.$on('$destroy', () => {
  //   window.removeEventListener('scroll', scrollHandle)
  // });

  const debHandleHeaderPosition = _debounce(_handleHeaderPosition, 500)

  // _getAdSettings()

  // $scope.$on('$locationChangeSuccess', () => {
  // $rootScope.$watch('post', () => {
  //   _checkAdVisibility()
  // });

  $scope.$on('googleAdLoaded', () => {
    debHandleHeaderPosition()
  })
}

export default NnHeaderMainDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-header-main/nn-header-main.directive.js